/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import $ from 'jquery';
import {load} from '@shopify/theme-sections';
import Variants from '@shopify/theme-variants';
import {formatMoney} from '@shopify/theme-currency';
import {register} from '@shopify/theme-sections';
import Swiper, { Navigation, Thumbs, FreeMode, A11y, Keyboard, Scrollbar } from 'swiper';

// // Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';
import 'swiper/css/scrollbar';

const selectors = {
    purchaseOptionBtn: '[data-purchase-option]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productImageWrapper: '[data-product-image-wrapper]',
    productFeaturedImage: '[data-variant-id]',
    productJson: '[data-product-page]',
    productPrice: '[data-product-price]',
    productThumbnailsSlider: 'carousel--product-thumbnails',
    productFeatureSlider: 'carousel--featured-product',
    productThumbs: '[data-product-single-thumbnail]',
    radioOptionSelector: '[data-radio-option-selector]',
    singleOptionSelector: '[data-single-option-selector]',
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productMediaTypeVideo: '[data-product-media-type-video]',
    productMediaTypeModel: '[data-product-media-type-model]',
    variantOptionLabels: '.swatch__option label',
    quantity: '#Quantity',
    productSwiperThumbs: null,
    productSwiperFeature: null,
    productSwiperFeatureSets: {},
    productSwiperThumbnailSets: {}
};

const cssClasses = {
    activeThumbnail: 'active-thumbnail',
    hide: 'hide',
};

const keyboardKeys = {
    ENTER: 13,
};

function toggleInnerFocus(slider) {
    let focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    $(focusableElements).each(function(index, el) {
        $(slider.slides).each(function(index, slide) {
            if (index === slider.activeIndex) {
                if (el === '.plyr') {
                    $(slide).find(el)
                    .attr('tabindex', "0");
                } else {
                    $(slide).find(el)
                    .removeAttr('tabindex');
                }
            } else {
                $(slide)
                .find(el)
                .attr('tabindex', '-1');
            }
        })
    })
}

$(document).ready(function(){
    var ProductVideo = (function() {
      var videos = {};

      var hosts = {
        html5: 'html5',
        youtube: 'youtube'
      };

      var attributes = {
        enableVideoLooping: 'enable-video-looping',
        videoId: 'video-id'
      };

      function init(videoContainer, sectionId) {
        if (!videoContainer.length) {
          return;
        }

        var videoElement = videoContainer.find('iframe, video')[0];
        var mediaId = videoContainer.data('mediaId');

        if (!videoElement) {
          return;
        }

        videos[mediaId] = {
          mediaId: mediaId,
          sectionId: sectionId,
          host: hostFromVideoElement(videoElement),
          container: videoContainer,
          element: videoElement,
          ready: function() {
            createPlayer(this);
          }
        };

        var video = videos[mediaId];
        switch (video.host) {
          case hosts.html5:
            setupPlyrVideos();
            break;
          case hosts.youtube:
            setupYouTubeVideos();
            break;
        }
      }

      function setupPlyrVideos() {
        // if (errors) {
        //   fallbackToNativeVideo();
        //   return;
        // }

        loadVideos(hosts.html5);
      }

      function setupYouTubeVideos() {

        window.YT.ready(function() {
            loadVideos(hosts.youtube);
        });
      }

      function createPlayer(video) {
        if (video.player) {
          return;
        }

        var productMediaWrapper = video.container.closest(
          selectors.productMediaWrapper
        );
        var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

        switch (video.host) {
          case hosts.html5:
            // eslint-disable-next-line no-undef
            video.player = new Shopify.Plyr(video.element, {
              loop: { active: enableLooping }
            });

            video.player.on('ready', function() {
                toggleInnerFocus(selectors.productSwiperFeature);
            })
            break;
          case hosts.youtube:
            var videoId = productMediaWrapper.data(attributes.videoId);

            video.player = new YT.Player(video.element, {
              videoId: videoId,
              events: {
                onStateChange: function(event) {
                  if (event.data === 0 && enableLooping) event.target.seekTo(0);
                }
              }
            });
            break;
        }

        productMediaWrapper.on('mediaHidden xrLaunch', function() {
          if (!video.player) return;

          if (video.host === hosts.html5) {
            video.player.pause();
          }

          if (video.host === hosts.youtube && video.player.pauseVideo) {
            video.player.pauseVideo();
          }
        });

        productMediaWrapper.on('mediaVisible', function() {
            if (!video.player) return;

            if (video.host === hosts.html5) {
                video.player.play();
            }

            if (video.host === hosts.youtube && video.player.playVideo) {
                video.player.playVideo();
            }
        });
      }

      function hostFromVideoElement(video) {
        if (video.tagName === 'VIDEO') {
          return hosts.html5;
        }

        if (video.tagName === 'IFRAME') {
          if (
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
              video.src
            )
          ) {
            return hosts.youtube;
          }
        }
        return null;
      }

      function loadVideos(host) {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];
            if (video.host === host) {
                video.ready();
            }
          }
        }
      }

      function fallbackToNativeVideo() {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];

            if (video.nativeVideo) continue;

            if (video.host === hosts.html5) {
              video.element.setAttribute('controls', 'controls');
              video.nativeVideo = true;
            }
          }
        }
      }

      function removeSectionVideos(sectionId) {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];

            if (video.sectionId === sectionId) {
              if (video.player) video.player.destroy();
              delete videos[key];
            }
          }
        }
      }

      return {
        init: init,
        hosts: hosts,
        loadVideos: loadVideos,
        removeSectionVideos: removeSectionVideos
      };
    })();

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register('product', {
        onLoad() {
            this.$container = $(this.container);
            this.namespace = `.${this.id}`;
            this.sellingPlanObserver = null;
            this.purchaseOptionObserver = null;
            var self = this;

            // Stop parsing if we don't have the product json script tag when loading
            // section in the Theme Editor
            if (!$(selectors.productJson, this.$container).html()) {
                return;
            }

            this.productSingleObject = JSON.parse(
                $(selectors.productJson, this.$container).html(),
            );

            const options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                radioOptionSelector: this.radioOptionSelector,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject,
            };

            this.settings = {};
            this.variants = new Variants(options);
            this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

            this.$container.on(
                `variantChange${this.namespace}`,
                (evt) => {
                    this.updatePDPInformation(evt);
                    // --- BEGIN: Restore variant URL update logic ---
                    if (options.enableHistoryState && evt.variant && evt.variant.id) {
                        var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + evt.variant.id;
                        window.history.replaceState({ path: newUrl }, '', newUrl);
                    }
                    // --- END: Restore variant URL update logic ---

                    // Update variant availability on every variant change
                    if (evt.variant) {
                        this.updateVariantAvailability(this.$container[0], evt.variant);
                    }
                }
            );
            this.$container.on(
                `variantPriceChange${this.namespace}`,
                this.updateProductPrices.bind(this),
            );

            $('.form__increment').on('click', function() {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            $(selectors.quantity).on('change', function() {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            if (this.$featuredImage.length > 0) {
                this.$container.on(
                    `variantImageChange${this.namespace}`,
                    this.updateImages.bind(this),
                );
            }

            this.initProductCarousel();
            this.initProductVideo();
            this.updateImages({
                variant: this.variants.currentVariant
            });
            this.initVariantTitles();
            this.initVariantHoverWatch();
            this.updateVariantAvailability(this.$container[0], this.variants.currentVariant);
            this.initStickyCart();
            this.initSellingPlanListeners();
            this.initVariantUrl();

            // Initialize sample display and ingredients for current variant
            console.log('Initializing with current variant:', this.variants.currentVariant);
            if (this.variants.currentVariant) {
                console.log('Calling changeVariantSample on init');
                this.changeVariantSample({
                    variant: this.variants.currentVariant
                });
                console.log('Calling changeIngredients on init');
                this.changeIngredients({
                    variant: this.variants.currentVariant
                });
            } else {
                console.log('No current variant found for initialization');
            }
        },

        initProductVideo: function() {
            var sectionId = this.id;
            $(selectors.productMediaTypeVideo, this.$container).each(function() {
                var $el = $(this);
                ProductVideo.init($el, sectionId);
            });
        },

        initProductCarousel: function() {
            let self = this;
            let productFeatureSwiper;
            let productThumbnailSwiper;
            let useFeaturedScrollbar = false;
            let isPeePadsMobile = false;
            // -------------------------------------
            // Carousel Products
            // -------------------------------------

            const currentThumbnailCarousel = this.$container.find(
                `.${selectors.productThumbnailsSlider}.current-variant`,
            )[0];
            const currentFeatureCarousel = this.$container.find(
                `.${selectors.productFeatureSlider}.current-variant`,
            )[0];
            const isPeePadsRevamp =
                document.body.classList.contains('template-product-pee-pads-revamp');

            // Only apply pee-pad-revamp-specific Swiper settings if template is active
            if (isPeePadsRevamp) {
                const currentThumbnailScrollbar = currentThumbnailCarousel?.parentElement?.querySelector('.product-thumbnails__scrollbar');
                const featureCarouselWidth =
                    currentFeatureCarousel?.clientWidth || this.$container?.[0]?.clientWidth || window.innerWidth;
                const isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
                isPeePadsMobile = isMobileViewport || featureCarouselWidth < 680;
                useFeaturedScrollbar = isPeePadsMobile && Boolean(currentThumbnailScrollbar);

                // Always initialize thumbnail Swiper for pee-pad-revamp
                productThumbnailSwiper = new Swiper('.'+selectors.productThumbnailsSlider+'.current-variant', {
                    modules: [Navigation, FreeMode, A11y, Keyboard, Scrollbar],
                    slidesPerView: isPeePadsMobile ? 2.2 : 3.5,
                    freeMode: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: true,
                    observer: true,
                    observeParents: true,
                    autoHeight: true,
                    watchOverflow: true,
                    threshold: 10,
                    spaceBetween: isPeePadsMobile ? 8 : 20,
                    scrollbar: currentThumbnailScrollbar
                        ? {
                            el: currentThumbnailScrollbar,
                            draggable: true,
                            snapOnRelease: false,
                            hide: false,
                        }
                        : undefined,
                    keyboard: {
                        enabled: false
                    },
                    a11y: false,
                    breakpoints: {
                        680: {
                            direction: "horizontal",
                            slidesPerView: 3.5,
                            spaceBetween: 20
                        }
                    },
                    multipleActiveThumbs: false
                });

                // Find arrows using DOM traversal instead of selector
                const arrowsContainer = currentFeatureCarousel?.nextElementSibling;
                const nextArrowEl = arrowsContainer?.querySelector('.swiper-button-next-product');
                const prevArrowEl = arrowsContainer?.querySelector('.swiper-button-prev-product');

                productFeatureSwiper = new Swiper('.'+selectors.productFeatureSlider+'.current-variant', {
                    modules: useFeaturedScrollbar ? [Navigation, Thumbs, Scrollbar] : [Navigation, Thumbs],
                    spaceBetween: 0,
                    slidesPerView: isPeePadsMobile ? 1.2 : 1,
                    breakpoints: {
                        0: {
                            slidesPerView: 1.2,
                        },
                        680: {
                            slidesPerView: 1,
                        },
                    },
                    navigation: (isPeePadsMobile || !nextArrowEl || !prevArrowEl) ? false : {
                        nextEl: nextArrowEl,
                        prevEl: prevArrowEl,
                    },
                    observer: true,
                    observeParents: true,
                    autoHeight: true,
                    watchOverflow: !isPeePadsMobile,
                    allowTouchMove: true,
                    simulateTouch: true,
                    scrollbar: useFeaturedScrollbar
                        ? {
                            el: currentThumbnailScrollbar,
                            draggable: true,
                            snapOnRelease: false,
                            hide: false,
                        }
                        : undefined,
                    thumbs: {
                        swiper: !isPeePadsMobile && productThumbnailSwiper?.$el ? productThumbnailSwiper : null,
                    },
                    on: {
                        init: function() {
                            toggleInnerFocus(this);
                        }
                    }
                });

                // ...existing Swiper event and sync logic...
                productFeatureSwiper.on('slideChange', function () {
                  var previousSlideIndex = productFeatureSwiper.previousIndex,
                      currentSlideIndex = productFeatureSwiper.activeIndex;
                  var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                      previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');
                  previousMedia.trigger("mediaHidden");
                  currentMedia.trigger("mediaVisible");
                  if (!isPeePadsMobile) {
                      self.slideToSlide(productThumbnailSwiper, currentSlideIndex, true);
                  }
                  toggleInnerFocus(this);
                });

                if (productThumbnailSwiper) {
                    $(productThumbnailSwiper.slides).each(function(index, slide) {
                        $(slide).on('focus', function(e) {
                            let slideIndex = slide.getAttribute('data-index');
                            self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                            self.slideToSlide(productFeatureSwiper, slideIndex, true);
                            $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                                $(thumbnailSlide).attr('tabindex', '0');
                            })
                        })
                        $(slide).on('keydown', function(e) {
                            if (e.key === "Enter") {
                                $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                                    $(thumbnailSlide).attr('tabindex', '-1');
                                })
                                $(slide).attr('tabindex', '0');
                                let slideIndex = parseInt(slide.getAttribute('data-index'));
                                productFeatureSwiper.slides[slideIndex].focus();
                            }
                        })
                    });

                    $(productThumbnailSwiper.navigation.nextEl).on('click', function(e) {
                        let slideIndex = productThumbnailSwiper.activeIndex;
                        self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                        self.slideToSlide(productFeatureSwiper, slideIndex, true);
                    })

                    $(productThumbnailSwiper.navigation.prevEl).on('click', function(e) {
                        let slideIndex = productThumbnailSwiper.activeIndex;
                        self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                        self.slideToSlide(productFeatureSwiper, slideIndex, true);
                    })
                }

                selectors.productSwiperThumbs = productThumbnailSwiper;
                selectors.productSwiperFeature = productFeatureSwiper;

                let variantId = $(productFeatureSwiper.wrapperEl).parent().attr('data-variant-id');
                if (!selectors.productSwiperFeatureSets[variantId]) {
                    selectors.productSwiperFeatureSets[variantId] = productFeatureSwiper;
                    selectors.productSwiperThumbnailSets[variantId] = productThumbnailSwiper;
                }

                let numOfSlides = productFeatureSwiper.wrapperEl.querySelectorAll(".swiper-slide").length;
                if( numOfSlides == 1 ) {
                    productFeatureSwiper.wrapperEl.parentNode.classList.add("hide-arrows")
                }

                setTimeout(() => {
                    if (productFeatureSwiper?.update) {
                        productFeatureSwiper.update();
                    }
                    if (productThumbnailSwiper?.update) {
                        productThumbnailSwiper.update();
                    }
                    if (useFeaturedScrollbar && productFeatureSwiper?.scrollbar?.updateSize) {
                        productFeatureSwiper.scrollbar.updateSize();
                    }
                    if (!useFeaturedScrollbar && productThumbnailSwiper?.scrollbar?.updateSize) {
                        productThumbnailSwiper.scrollbar.updateSize();
                    }
                }, 80);

                if (isPeePadsMobile) {
                    window.addEventListener('load', () => {
                        if (productFeatureSwiper?.update) {
                            productFeatureSwiper.update();
                        }
                        if (productFeatureSwiper?.scrollbar?.updateSize) {
                            productFeatureSwiper.scrollbar.updateSize();
                        }
                        if (productFeatureSwiper?.slideTo) {
                            productFeatureSwiper.slideTo(productFeatureSwiper.activeIndex, 0);
                        }
                    }, { once: true });
                }
            } else {
                // For all other templates, use default Swiper settings
                productThumbnailSwiper = new Swiper('.'+selectors.productThumbnailsSlider+'.current-variant', {
                    modules: [Navigation, FreeMode, A11y, Keyboard],
                    slidesPerView: 5,
                    freeMode: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: true,
                    observer: true,
                    observeParents: true,
                    autoHeight: true,
                    watchOverflow: true,
                    threshold: 10,
                    spaceBetween: 0,
                    keyboard: {
                        enabled: false
                    },
                    a11y: false,
                    breakpoints: {
                        680: {
                            direction: "horizontal",
                            slidesPerView: 6,
                            spaceBetween: 0
                        }
                    },
                    multipleActiveThumbs: false
                });

                productFeatureSwiper = new Swiper('.'+selectors.productFeatureSlider+'.current-variant', {
                    modules: [Navigation, Thumbs],
                    spaceBetween: 0,
                    slidesPerView: 1,
                    breakpoints: undefined,
                    navigation: {
                        nextEl: '.current-variant + .carousel--product-arrows .swiper-button-next-product',
                        prevEl: '.current-variant + .carousel--product-arrows .swiper-button-prev-product',
                    },
                    observer: true,
                    observeParents: true,
                    autoHeight: true,
                    watchOverflow: true,
                    allowTouchMove: true,
                    simulateTouch: true,
                    thumbs: {
                        swiper: productThumbnailSwiper.$el ? productThumbnailSwiper : null,
                    },
                    on: {
                        init: function() {
                            toggleInnerFocus(this);
                        }
                    }
                });

                // ...existing Swiper event and sync logic...
                productFeatureSwiper.on('slideChange', function () {
                  var previousSlideIndex = productFeatureSwiper.previousIndex,
                      currentSlideIndex = productFeatureSwiper.activeIndex;
                  var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                      previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');
                  previousMedia.trigger("mediaHidden");
                  currentMedia.trigger("mediaVisible");
                  self.slideToSlide(productThumbnailSwiper, currentSlideIndex, true);
                  toggleInnerFocus(this);
                });

                $(productThumbnailSwiper.slides).each(function(index, slide) {
                    $(slide).on('focus', function(e) {
                        let slideIndex = slide.getAttribute('data-index');
                        self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                        self.slideToSlide(productFeatureSwiper, slideIndex, true);
                        $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                            $(thumbnailSlide).attr('tabindex', '0');
                        })
                    })
                    $(slide).on('keydown', function(e) {
                        if (e.key === "Enter") {
                            $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                                $(thumbnailSlide).attr('tabindex', '-1');
                            })
                            $(slide).attr('tabindex', '0');
                            let slideIndex = parseInt(slide.getAttribute('data-index'));
                            productFeatureSwiper.slides[slideIndex].focus();
                        }
                    })
                });

                $(productThumbnailSwiper.navigation.nextEl).on('click', function(e) {
                    let slideIndex = productThumbnailSwiper.activeIndex;
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                })

                $(productThumbnailSwiper.navigation.prevEl).on('click', function(e) {
                    let slideIndex = productThumbnailSwiper.activeIndex;
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                })

                selectors.productSwiperThumbs = productThumbnailSwiper;
                selectors.productSwiperFeature = productFeatureSwiper;

                let variantId = $(productFeatureSwiper.wrapperEl).parent().attr('data-variant-id');
                if (!selectors.productSwiperFeatureSets[variantId]) {
                    selectors.productSwiperFeatureSets[variantId] = productFeatureSwiper;
                    selectors.productSwiperThumbnailSets[variantId] = productThumbnailSwiper;
                }

                let numOfSlides = productFeatureSwiper.wrapperEl.querySelectorAll(".swiper-slide").length;
                if( numOfSlides == 1 ) {
                    productFeatureSwiper.wrapperEl.parentNode.classList.add("hide-arrows")
                }

                setTimeout(() => {
                    if (productFeatureSwiper?.update) {
                        productFeatureSwiper.update();
                    }
                    if (productThumbnailSwiper?.update) {
                        productThumbnailSwiper.update();
                    }
                }, 80);
            }

            productFeatureSwiper.on('slideChange', function () {
              // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                var previousSlideIndex = productFeatureSwiper.previousIndex,
                    currentSlideIndex = productFeatureSwiper.activeIndex;

                // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                    previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');

                previousMedia.trigger("mediaHidden");
                currentMedia.trigger("mediaVisible");
                if (!isPeePadsMobile) {
                    self.slideToSlide(productThumbnailSwiper, currentSlideIndex, true);
                }
                toggleInnerFocus(this);
            });

            if (productThumbnailSwiper) {
                $(productThumbnailSwiper.slides).each(function(index, slide) {
                    $(slide).on('focus', function(e) {
                        let slideIndex = slide.getAttribute('data-index');
                        self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                        self.slideToSlide(productFeatureSwiper, slideIndex, true);
                        $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                            $(thumbnailSlide).attr('tabindex', '0');
                        })
                    })
                    $(slide).on('keydown', function(e) {
                        if (e.key === "Enter") {
                            $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                                $(thumbnailSlide).attr('tabindex', '-1');
                            })
                            $(slide).attr('tabindex', '0');
                            let slideIndex = parseInt(slide.getAttribute('data-index'));
                            productFeatureSwiper.slides[slideIndex].focus();
                        }
                    })
                });

                $(productThumbnailSwiper.navigation.nextEl).on('click', function(e) {
                    let slideIndex = productThumbnailSwiper.activeIndex;
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                })

                $(productThumbnailSwiper.navigation.prevEl).on('click', function(e) {
                    let slideIndex = productThumbnailSwiper.activeIndex;
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                })
            }


            selectors.productSwiperThumbs = productThumbnailSwiper;
            selectors.productSwiperFeature = productFeatureSwiper;

            let variantId = $(productFeatureSwiper.wrapperEl).parent().attr('data-variant-id');
            if (!selectors.productSwiperFeatureSets[variantId]) {
                selectors.productSwiperFeatureSets[variantId] = productFeatureSwiper;
                selectors.productSwiperThumbnailSets[variantId] = productThumbnailSwiper;
            }

            let numOfSlides = productFeatureSwiper.wrapperEl.querySelectorAll(".swiper-slide").length;
            if( numOfSlides == 1 ) {
                productFeatureSwiper.wrapperEl.parentNode.classList.add("hide-arrows")
            }

            setTimeout(() => {
                if (productFeatureSwiper?.update) {
                    productFeatureSwiper.update();
                }
                if (productThumbnailSwiper?.update) {
                    productThumbnailSwiper.update();
                }
                if (useFeaturedScrollbar && productFeatureSwiper?.scrollbar?.updateSize) {
                    productFeatureSwiper.scrollbar.updateSize();
                }
                if (!useFeaturedScrollbar && productThumbnailSwiper?.scrollbar?.updateSize) {
                    productThumbnailSwiper.scrollbar.updateSize();
                }
            }, 80);

            if (isPeePadsMobile) {
                window.addEventListener('load', () => {
                    if (productFeatureSwiper?.update) {
                        productFeatureSwiper.update();
                    }
                    if (productFeatureSwiper?.scrollbar?.updateSize) {
                        productFeatureSwiper.scrollbar.updateSize();
                    }
                    if (productFeatureSwiper?.slideTo) {
                        productFeatureSwiper.slideTo(productFeatureSwiper.activeIndex, 0);
                    }
                }, { once: true });
            }
        },
        changeProductCarousel(evt) {
            let variantId;

            if (evt.variant && evt.variant.id) {
                variantId = evt.variant.id;
            } else {
                variantId = "placeholder";
            }

            let carousels           = evt.currentTarget.querySelectorAll(`.carousel--featured-product[data-variant-id]`);
            let thumbnailCarousels  = evt.currentTarget.querySelectorAll(`.carousel--product-thumbnails[data-variant-id]`);

            if(carousels.length != 0) {
                let newCarousel             = evt.currentTarget.querySelector(`.carousel--featured-product[data-variant-id="${variantId}"]`);
                let newThumbnailCarousel    = evt.currentTarget.querySelector(`.carousel--product-thumbnails[data-variant-id="${variantId}"]`);

                if (newCarousel && newThumbnailCarousel) {
                    // FIRST: Show the new gallery
                    newCarousel.classList.add('current-variant');
                    newThumbnailCarousel.classList.add('current-variant');

                    // Explicitly show wrappers with !important via cssText
                    if (newCarousel.parentElement && newCarousel.parentElement.classList.contains('carousel--featured-product-wrapper')) {
                        newCarousel.parentElement.style.cssText = 'display: block !important;';
                    }
                    if (newThumbnailCarousel.parentElement && newThumbnailCarousel.parentElement.classList.contains('product-thumbnails__wrapper')) {
                        newThumbnailCarousel.parentElement.style.cssText = 'display: block !important;';
                    }

                    // THEN: Hide all other carousels
                    carousels.forEach(function(carousel) {
                        if (carousel !== newCarousel) {
                            carousel.classList.remove('current-variant');
                            if (carousel.parentElement && carousel.parentElement.classList.contains('carousel--featured-product-wrapper')) {
                                carousel.parentElement.style.cssText = 'display: none !important;';
                            }
                        }
                    });

                    thumbnailCarousels.forEach(function(carousel) {
                        if (carousel !== newThumbnailCarousel) {
                            carousel.classList.remove('current-variant');
                            if (carousel.parentElement && carousel.parentElement.classList.contains('product-thumbnails__wrapper')) {
                                carousel.parentElement.style.cssText = 'display: none !important;';
                            }
                        }
                    });

                    // Explicitly show wrappers with !important via cssText
                    if (newCarousel.parentElement && newCarousel.parentElement.classList.contains('carousel--featured-product-wrapper')) {
                        newCarousel.parentElement.style.cssText = 'display: block !important;';
                    }
                    if (newThumbnailCarousel.parentElement && newThumbnailCarousel.parentElement.classList.contains('product-thumbnails__wrapper')) {
                        newThumbnailCarousel.parentElement.style.cssText = 'display: block !important;';
                    }

                    // THEN: Hide all other carousels
                    carousels.forEach(function(carousel) {
                        if (carousel !== newCarousel) {
                            carousel.classList.remove('current-variant');
                            if (carousel.parentElement && carousel.parentElement.classList.contains('carousel--featured-product-wrapper')) {
                                carousel.parentElement.style.cssText = 'display: none !important;';
                            }
                        }
                    });

                    thumbnailCarousels.forEach(function(carousel) {
                        if (carousel !== newThumbnailCarousel) {
                            carousel.classList.remove('current-variant');
                            if (carousel.parentElement && carousel.parentElement.classList.contains('product-thumbnails__wrapper')) {
                                carousel.parentElement.style.cssText = 'display: none !important;';
                            }
                        }
                    });

                    // Disable old carousel
                    if (selectors.productSwiperFeature) {
                        selectors.productSwiperFeature.disable();
                        selectors.productSwiperFeature.destroy(true, true);
                        selectors.productSwiperFeature = null;
                    }
                    if (selectors.productSwiperThumbs) {
                        selectors.productSwiperThumbs.disable();
                        selectors.productSwiperThumbs.destroy(true, true);
                        selectors.productSwiperThumbs = null;
                    }

                    // Clear cached instances for this variant
                    if (selectors.productSwiperFeatureSets && selectors.productSwiperFeatureSets[variantId]) {
                        selectors.productSwiperFeatureSets[variantId].destroy(true, true);
                        delete selectors.productSwiperFeatureSets[variantId];
                    }
                    if (selectors.productSwiperThumbnailSets && selectors.productSwiperThumbnailSets[variantId]) {
                        selectors.productSwiperThumbnailSets[variantId].destroy(true, true);
                        delete selectors.productSwiperThumbnailSets[variantId];
                    }

                    // Wait for DOM to update, then reinitialize
                    setTimeout(() => {
                        this.initProductCarousel();

                        // Update the carousel references
                        if (selectors.productSwiperFeatureSets && selectors.productSwiperFeatureSets[variantId]) {
                            selectors.productSwiperFeature = selectors.productSwiperFeatureSets[variantId];
                            selectors.productSwiperThumbs = selectors.productSwiperThumbnailSets[variantId];
                        }

                        // Force Swiper to update and recalculate after initialization
                        setTimeout(() => {
                            if (selectors.productSwiperFeature && selectors.productSwiperFeature.update) {
                                selectors.productSwiperFeature.update();
                                selectors.productSwiperFeature.updateSlides();
                                selectors.productSwiperFeature.updateProgress();
                                selectors.productSwiperFeature.updateSlidesClasses();
                            }
                            if (selectors.productSwiperThumbs && selectors.productSwiperThumbs.update) {
                                selectors.productSwiperThumbs.update();
                                selectors.productSwiperThumbs.updateSlides();
                                selectors.productSwiperThumbs.updateProgress();
                                selectors.productSwiperThumbs.updateSlidesClasses();
                            }
                        }, 50);
                    }, 10);
                }
            }
        },
        initVariantTitles() {
            this.changeVariantTitles(this.variants.currentVariant);
        },
        disableVariants(target, valuesToEnable) {

            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var option1 = $(target).find('input[data-index="option1"]');
            var option2 = $(target).find('input[data-index="option2"]');
            var option3 = $(target).find('input[data-index="option3"]');

            var self = this;

            // If there are 3 option selectors
            if (optionSelector3.length) {

                // If the third option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 2.
                if (is_swatch_selector3 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    })
                    option2.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    })

                    option3.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option3.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');

                            // If this option is currently selected but now unavailable, auto-select first available
                            if (input.checked && valuesToEnable.option3.length > 0) {
                                input.checked = false;
                                var firstAvailable = option3.filter(function() {
                                    return valuesToEnable.option3.includes(this.value);
                                })[0];
                                if (firstAvailable) {
                                    firstAvailable.checked = true;
                                    $(firstAvailable).trigger('change');
                                }
                            }
                        }
                    })

                // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 3.
                } else if (is_swatch_selector2 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    });

                    option2.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option2.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');

                            // If this option is currently selected but now unavailable, auto-select first available
                            if (input.checked && valuesToEnable.option2.length > 0) {
                                input.checked = false;
                                var firstAvailable = option2.filter(function() {
                                    return valuesToEnable.option2.includes(this.value);
                                })[0];
                                if (firstAvailable) {
                                    firstAvailable.checked = true;
                                    $(firstAvailable).trigger('change');
                                }
                            }
                        }
                    });

                // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2 and 3.
                } else if (is_swatch_selector1 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');

                            // If this option is currently selected but now unavailable, auto-select first available
                            if (input.checked && valuesToEnable.option1.length > 0) {
                                input.checked = false;
                                var firstAvailable = option1.filter(function() {
                                    return valuesToEnable.option1.includes(this.value);
                                })[0];
                                if (firstAvailable) {
                                    firstAvailable.checked = true;
                                    $(firstAvailable).trigger('change');
                                }
                            }
                        }
                    })
                }

            // If there are 2 option selectors
            } else if (optionSelector2.length) {

                // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1.
                if (is_swatch_selector2 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    });

                    option2.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option2.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');

                            // If this option is currently selected but now unavailable, auto-select first available
                            if (input.checked && valuesToEnable.option2.length > 0) {
                                input.checked = false;
                                var firstAvailable = option2.filter(function() {
                                    return valuesToEnable.option2.includes(this.value);
                                })[0];
                                if (firstAvailable) {
                                    firstAvailable.checked = true;
                                    $(firstAvailable).trigger('change');
                                }
                            }
                        }
                    });

                // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2.
                } else if (is_swatch_selector1 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');

                            // If this option is currently selected but now unavailable, auto-select first available
                            if (input.checked && valuesToEnable.option1.length > 0) {
                                input.checked = false;
                                var firstAvailable = option1.filter(function() {
                                    return valuesToEnable.option1.includes(this.value);
                                })[0];
                                if (firstAvailable) {
                                    firstAvailable.checked = true;
                                    $(firstAvailable).trigger('change');
                                }
                            }
                        }
                    })
                }
            }
        },
        updateVariantAvailability(target, variant) {

            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var availableValues = {
                option1: [],
                option2: [],
                option3: []
            }

            var variants = this.variants.product.variants;
            var currentSelectedOptions = this.variants._getCurrentOptions();

            // Combine all available variants
            var availableVariants = variants.filter(function(el) {

                // If there are 3 option selectors
                if (optionSelector3.length) {

                    var currentVariant = {
                        option1: currentSelectedOptions[0].value,
                        option2: currentSelectedOptions[1].value,
                        option3: currentSelectedOptions[2].value
                    };

                    // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 2.
                    if (is_swatch_selector3 == true) {

                        // Option 3 based on selected Option 1 and 2
                        if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option2 === el.option2 || !el.option2)) {
                            return true;
                        }

                    // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 3.
                    } else if (is_swatch_selector2 == true) {

                        if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option3 === el.option3 || !el.option3)) {
                            return true;
                        }

                    // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2 and 3.
                    } else if (is_swatch_selector1 == true) {

                        if ((currentVariant.option2 === el.option2 || !el.option2) && (currentVariant.option3 === el.option3 || !el.option3)) {
                            return true;
                        }
                    }

                // If there are only 2 option selectors
                } else if (optionSelector2.length) {

                    var currentVariant = {
                        option1: currentSelectedOptions[0].value,
                        option2: currentSelectedOptions[1].value
                    };

                    // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                    if (is_swatch_selector2 == true) {

                        if (currentVariant.option1 === el.option1 || !el.option1) {
                            return true;
                        }

                    // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2.
                    } else if (is_swatch_selector1 == true) {

                        if (currentVariant.option2 === el.option2 || !el.option2) {
                            return true;
                        }
                    }
                }

                });

            availableVariants = Object.assign({}, availableVariants);

            for (var property in availableVariants) {
                if (availableVariants.hasOwnProperty(property)) {
                  var item = availableVariants[property],
                      option1 = item.option1,
                      option2 = item.option2,
                      option3 = item.option3;

                  if (option1) {
                    if (availableValues.option1.indexOf(option1) === -1) {
                        availableValues.option1.push(option1);
                    }
                  }
                  if (option2) {
                    if (availableValues.option2.indexOf(option2) === -1) {
                      availableValues.option2.push(option2);
                    }
                  }
                  if (option3) {
                    if (availableValues.option3.indexOf(option3) === -1) {
                      availableValues.option3.push(option3);
                    }
                  }
                }
            }


            this.disableVariants(target, availableValues);
        },


        slideToSlide(slider, slideIndex, transition) {
            if (transition) {
                slider.slideTo(slideIndex);
            } else {
                slider.slideTo(slideIndex, 0);
            }
        },

        // triggering change image when using with Slider
        swapImage(imageId) {

            let newImageId = imageId;

            // If "imageId" is not defined in the function parameter, find it by the current product image
            if (typeof newImageId === 'undefined') {
                newImageId = $(
                    `${selectors.productImageWrapper}:not('.${cssClasses.hide}')`,
                ).data('image-id');
            }
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState(evt) {
            const variant = evt.variant;
            this.updateVariantAvailability(evt.target, variant);

           if (variant) {
                const skuElement = document.querySelector(`#marketSkuJSON-${variant.id}`);
                if (!skuElement) {
                    console.warn('No SKU JSON element found for variant', variant.id);
                    return;
                }

                const marketSkuObject = JSON.parse(skuElement.innerHTML);
                const selectedVariantSku = marketSkuObject.variant_sku;

                const widget = document.querySelector('.ps-widget');

                if (widget) {
                    widget.setAttribute('ps-sku', selectedVariantSku);
                    PriceSpider.rebind();
                }
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        changeVariantTitles(evt) {
          $('.swatch__option input[data-single-option-selector]:checked').each(function() {
            var container = $(this).parents('.form__element');
            var subtitle = container.find('.swatch__title .swatch__subtitle');
            subtitle.text($(this).val());
          })
        },

        tempChangeVariantTitle(evt) {
          var target = evt.currentTarget;
          var newLabel = target.innerText;
          var container = $(target).parents('.form__element');
          var subtitle = container.find('.swatch__title .swatch__subtitle');
          subtitle.text(newLabel);
        },

        initVariantHoverWatch() {
          var changeVariantTitles = this.changeVariantTitles;
          var tempChangeVariantTitle = this.tempChangeVariantTitle;
          $('.swatch__option input[data-single-option-selector] + label.form__option-label').each(function() {
            $(this).on('mouseenter', tempChangeVariantTitle).on('mouseleave', changeVariantTitles);
          });
        },

        changeIngredients(evt) {
            console.log('changeIngredients called', evt);
            const variant = evt.variant;  // Extract the variant from the event
            console.log('Looking for variant ID:', variant.id.toString());
            console.log('Ingredient elements found:', $('.variant-ingredients').length);

            let hasVariantIngredients = false;
            const $productIngredients = $('.product-ingredients');
            const hasProductIngredients = $productIngredients.length > 0 && $productIngredients.text().trim() !== '';

            // Hide all variant ingredients first
            $('.variant-ingredients').hide();

            // Look for variant-specific ingredients for the current variant
            $('.variant-ingredients').each(function() {
                const $el = $(this);
                const variantId = $el.data('variant-id')?.toString();
                console.log('Checking ingredient element with variant ID:', variantId);

                if (variantId === variant.id.toString()) {
                    console.log('Variant ingredient match found! Showing element');
                    $el.show();
                    hasVariantIngredients = $el.text().trim() !== '';
                    return false; // Break out of loop once found
                }
            });

            // Show/hide product ingredients based on priority logic
            if (hasVariantIngredients) {
                console.log('Variant has ingredients, hiding product ingredients');
                $productIngredients.hide(); // Hide product ingredients if variant has them
            } else if (hasProductIngredients) {
                console.log('No variant ingredients, showing product ingredients');
                $productIngredients.show(); // Show product ingredients as fallback
            }

            // Show/hide the entire ingredients accordion
            const $ingredientsAccordion = $('#accordion-ingredients');
            if (hasVariantIngredients || hasProductIngredients) {
                console.log('Showing ingredients accordion');
                $ingredientsAccordion.show();
            } else {
                console.log('Hiding ingredients accordion');
                $ingredientsAccordion.hide();
            }
        },

        changeVariantSample(evt) {
            console.log('changeVariantSample called', evt);
            const variantId = evt.variant.id.toString();
            console.log('Looking for variant ID:', variantId);

            const $sampleSection = $('#sample-cta-section');
            const $sampleLink = $('#current-sample-link');
            const $sampleMessage = $('#sample-already-added-message');
            let hasSample = false;
            let sampleId = null;

            // Look for sample data for the current variant
            $('.variant-sample-data').each(function() {
                const $el = $(this);
                const elVariantId = $el.data('variant-id')?.toString();
                console.log('Checking sample data for variant ID:', elVariantId);

                if (elVariantId === variantId) {
                    sampleId = $el.data('sample-id');
                    hasSample = true;
                    console.log('Sample found for variant! Sample ID:', sampleId);
                    return false; // Break out of loop
                }
            });

            // Show/hide the entire sample section and update the link
            if (hasSample && sampleId) {
                console.log('Showing sample section with sample ID:', sampleId);
                $sampleLink.attr('href', `/cart/add?id=${sampleId}`);

                // Check if sample is already in cart
                $.ajax({
                    url: '/cart.js',
                    cache: false,
                    dataType: "json",
                    success: function(cart) {
                        var sampleInCart = cart.items.some(function(item) {
                            return item.product_id === 9384986345749;
                        });

                        if (sampleInCart) {
                            // Sample already in cart - show message, hide link
                            $sampleLink.hide();
                            $sampleMessage.show();
                        } else {
                            // No sample in cart - show link, hide message
                            $sampleLink.show();
                            $sampleMessage.hide();
                        }

                        $sampleSection.show();
                    },
                    error: function() {
                        // On error, just show the link
                        $sampleLink.show();
                        $sampleMessage.hide();
                        $sampleSection.show();
                    }
                });
            } else {
                console.log('No sample found, hiding sample section');
                $sampleSection.hide();
            }
        },

        updatePDPInformation(evt) {
          this.updateAddToCartState(evt);
          this.changeVariantTitles(evt);
          this.changeProductCarousel(evt);
          this.changeIngredients(evt);
          this.changeVariantSample(evt);
        },

        updateImages(evt) {
            const variant = evt.variant;

            if (typeof variant.featured_media != 'undefined') {

                const imageId = this.id + "-" + variant.featured_media.id;

                this.swapImage(imageId);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices(evt) {
            const variant = evt.variant;
            if (!variant) {
                return;
            }
            const $comparePrice = $(selectors.comparePrice, this.$container);
            const $compareEls = $comparePrice.add(
                selectors.comparePriceText,
                this.$container,
            );
            const quantity = parseInt($(selectors.quantity).val(), 10) || 1;
            const sellingPlanId = this.getCurrentSellingPlanId();
            const sellingPlanAllocation = this.getSellingPlanAllocation(
                variant,
                sellingPlanId,
            );
            const unitPrice = sellingPlanAllocation
                ? sellingPlanAllocation.price ??
                  sellingPlanAllocation.per_delivery_price ??
                  variant.price
                : variant.price;
            const compareAtPrice = sellingPlanAllocation
                ? sellingPlanAllocation.compare_at_price ?? variant.compare_at_price
                : variant.compare_at_price;

            $(selectors.productPrice, this.$container).html(
                formatMoney(unitPrice, theme.moneyFormat),
            );

            const priceWithQuantity = unitPrice * quantity;
            $('#addToCartPricing').html(
                formatMoney(priceWithQuantity, theme.moneyFormat),
            );

            if (compareAtPrice > unitPrice) {
                $comparePrice.html(
                    formatMoney(compareAtPrice, theme.moneyFormat),
                );
                $compareEls.removeClass(cssClasses.hide);
                $(selectors.productPrice, this.$container).addClass('price__original--sale');
            } else {
                $comparePrice.html('');
                $compareEls.addClass(cssClasses.hide);
                $(selectors.productPrice, this.$container).removeClass('price__original--sale');
            }
        },

        getCurrentSellingPlanId() {
            const $checkedRadio = this.$container.find(
                'input[name="selling_plan"]:checked',
            );
            if ($checkedRadio.length) {
                return parseInt($checkedRadio.val(), 10) || null;
            }

            const $sellingPlanField = this.$container.find('[name="selling_plan"]').first();
            if ($sellingPlanField.length) {
                const value = $sellingPlanField.val();
                if (value) {
                    return parseInt(value, 10) || null;
                }
            }

            return null;
        },

        getSellingPlanAllocation(variant, sellingPlanId) {
            if (
                !variant ||
                !sellingPlanId ||
                !Array.isArray(variant.selling_plan_allocations)
            ) {
                return null;
            }

            const normalizedSellingPlanId = Number(sellingPlanId);

            return (
                variant.selling_plan_allocations.find(
                    allocation =>
                        Number(allocation.selling_plan_id) === normalizedSellingPlanId,
                ) || null
            );
        },

        initSellingPlanListeners() {
            const updatePrices = () => {
                if (this.variants?.currentVariant) {
                    this.updateProductPrices({
                        variant: this.variants.currentVariant,
                    });
                }
            };

            const sellingPlanSelector = 'input[name="selling_plan"], select[name="selling_plan"]';

            // Local (inside product container)
            this.$container.on(
                `change${this.namespace} input${this.namespace}`,
                sellingPlanSelector,
                updatePrices,
            );

            // Global fallback (Recharge sometimes appends selling_plan outside the container)
            $(document).on(
                `change${this.namespace} input${this.namespace}`,
                sellingPlanSelector,
                updatePrices,
            );

            // Recharge purchase option toggle (subscription vs onetime)
            const purchaseOptionSelector =
                '.rc-purchase-option__selector, input[name="purchaseOption"]';
            $(document).on(
                `click${this.namespace} change${this.namespace}`,
                purchaseOptionSelector,
                evt => {
                    console.log('[product] Recharge purchase option change detected', {
                        target: evt.currentTarget,
                        value: evt.currentTarget?.value,
                    });
                    updatePrices();
                },
            );

            // Mutation observer for Recharge widgets (captures Shadow DOM/dynamic rendering)
            const purchaseOptionTarget = document.body;
            if (purchaseOptionTarget) {
                this.purchaseOptionObserver = new MutationObserver(mutations => {
                    const shouldUpdate = mutations.some(mutation => {
                        if (mutation.type === 'attributes' && mutation.target) {
                            const el = mutation.target;
                            return (
                                el.classList?.contains('rc-purchase-option__selector') ||
                                el.classList?.contains('rc-purchase-option__input') ||
                                el.getAttribute?.('name') === 'purchaseOption' ||
                                el.getAttribute?.('name') === 'selling_plan'
                            );
                        }

                        if (mutation.type === 'childList') {
                            return Array.from(mutation.addedNodes || []).some(node => {
                                if (!node.querySelector) return false;
                                return (
                                    node.matches?.(purchaseOptionSelector) ||
                                    node.querySelector(purchaseOptionSelector) ||
                                    node.querySelector('input[name=\"selling_plan\"]')
                                );
                            });
                        }

                        return false;
                    });

                    if (shouldUpdate) {
                        console.log('[product] Recharge mutation detected, refreshing prices');
                        updatePrices();
                    }
                });

                this.purchaseOptionObserver.observe(purchaseOptionTarget, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['checked', 'value'],
                });
            }

            const widgetEl = this.$container.find('recharge-subscription-widget')[0];

            if (widgetEl) {
                this.sellingPlanObserver = new MutationObserver(mutationsList => {
                    const hasSellingPlanMutation = mutationsList.some(mutation => {
                        if (mutation.type === 'attributes') {
                            return (
                                mutation.target &&
                                mutation.target.matches &&
                                mutation.target.matches('[name="selling_plan"]')
                            );
                        }

                        if (mutation.type === 'childList') {
                            return Array.from(mutation.addedNodes || []).some(node => {
                                if (!node || !node.querySelector) {
                                    return false;
                                }

                                return (
                                    node.matches?.('[name="selling_plan"]') ||
                                    node.querySelector('[name="selling_plan"]')
                                );
                            });
                        }

                        return false;
                    });

                    if (hasSellingPlanMutation) {
                        updatePrices();
                    }
                });

                this.sellingPlanObserver.observe(widgetEl, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['value', 'checked'],
                });
            }

            updatePrices();
        },

        initStickyCart() {
          let options = {
            rootMargin: '100px 0px 0px 0px',
            threshold: [0,0.01,1]
          }

          let target = document.querySelector('#productStickyContainer');

          let observer = new IntersectionObserver(this.showHideStickyCart, options);

          observer.observe(target);

          // Mobile cart button
          $('#addToCartSticky').on('click', function() {
            target.scrollIntoView({ behavior: 'smooth' });
          })

        },

        showHideStickyCart(entries, observer) {
            let entry = entries[0];
            if (entry.intersectionRatio >= 1) {
                entry.target.classList.remove('product__sticky--show');
            } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
                entry.target.classList.add('product__sticky--show');
                entry.target.classList.remove('product__sticky--hide');
            } else {
                entry.target.classList.add('product__sticky--hide');
            }
        },

        // On page load, ensure ?variant= is in the URL and PS is bound to the
        // correct variant SKU. Without this, PriceSpider reads the URL variant
        // param to determine which sellers to show — if it's absent it may default
        // to the wrong variant and display "No Sellers Found".
        initVariantUrl() {
            const variant = this.variants?.currentVariant;
            if (!variant) return;

            const url    = new URL(window.location.href);
            const hasParam = url.searchParams.has('variant');

            // Always push the correct variant into the URL (replaceState so no
            // back-button side-effect), then rebind PS with the matching SKU.
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());

            if (!hasParam) {
                // Param was missing — PS may have loaded with the wrong SKU.
                // Rebind it now with the SKU for the actual selected variant.
                const skuElement = document.querySelector(`#marketSkuJSON-${variant.id}`);
                const widget     = document.querySelector('.ps-widget');

                if (skuElement && widget && typeof PriceSpider !== 'undefined') {
                    const { variant_sku } = JSON.parse(skuElement.innerHTML);
                    widget.setAttribute('ps-sku', variant_sku);
                    PriceSpider.rebind();
                }
            }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
            this.$container.off(this.namespace);
            $(document).off(this.namespace);
            if (this.sellingPlanObserver) {
                this.sellingPlanObserver.disconnect();
            }
            if (this.purchaseOptionObserver) {
                this.purchaseOptionObserver.disconnect();
            }
        },
    });

    load('product');
})

document.addEventListener('DOMContentLoaded', function() {
  // Show the first sample link by default (already done by Liquid, but good to enforce)
  $('.sample-cta-link').hide();
  $('.sample-cta-link').first().show();
});
